'use es6';

import { Map as ImmutableMap } from 'immutable';
var initialState = ImmutableMap();
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.meta && action.meta.request) {
    return state.set(action.meta.request.key, action.meta.request.status);
  }

  return state;
}